export const shiftPersonal = [

    {
        "Work_Supp_Key" : "0001",
        "Start_Date" : "16/01/2018",
        "Start_Time":"16:29",
        "End_Date" : "16/01/2018",
        "End_Time" :"16:29",
    },
    {
        "Work_Supp_Key" : "0923",
        "Start_Date" : "16/01/2018",
        "Start_Time":"16:29",
        "End_Date" : "16/01/2018",
        "End_Time" :"16:29",
    },
    {
        "Work_Supp_Key" : "1234",
        "Start_Date" : "16/01/2018",
        "Start_Time":"16:29",
        "End_Date" : "16/01/2018",
        "End_Time" :"16:29",
    },
]